import React from 'react'
import parse from 'html-react-parser'

const BasicPage = ({ title, content }) => {

  return (
    <section className='basic-page'>
      <div className='basic-page__inner'>
        { title && <h1>{parse(title)}</h1> }
        { content && <div>{parse(content)}</div> }
      </div>
    </section>
  )
}

export default BasicPage